// Perímetros do Decreto nº 13.016, de 10/06/2026 — cria o Parque Nacional
// Povos Indígenas do Rio Tanaru (Chupinguaia, Corumbiara, Parecis e
// Pimenteiras do Oeste/RO).
//
// Fonte: memorial descritivo do decreto (c.p.a. em UTM Zona 20 Sul,
// SIRGAS 2000 / EPSG:31980), transformado pra WGS84 via PostGIS
// ST_Transform. Área calculada por ST_Area no plano UTM bate com o texto
// do decreto (~7.638 ha). Gerado por script — não editar pontos na mão.

export interface TanaruPerimetro {
  geometry: GeoJSON.Polygon;
  areaHa: number;
  pontos: number;
}

export const TANARU_META = {
  decreto: 'Decreto nº 13.016, de 10 de junho de 2026',
  nome: 'Parque Nacional Povos Indígenas do Rio Tanaru',
  municipios: ['Chupinguaia', 'Corumbiara', 'Parecis', 'Pimenteiras do Oeste'],
  uf: 'RO',
  datum: 'SIRGAS 2000 · UTM Zona 20 Sul',
  dou: '11/06/2026',
  url: 'https://www.planalto.gov.br/ccivil_03/_ato2023-2026/2026/decreto/d13016.htm',
};

export const TANARU_PARQUE: TanaruPerimetro = {
  geometry: {
    type: 'Polygon' as const,
    coordinates: [[
      [-61.332594, -12.57786],
      [-61.332094, -12.628526],
      [-61.326369, -12.629344],
      [-61.326732, -12.659561],
      [-61.331958, -12.661288],
      [-61.332094, -12.665196],
      [-61.32655, -12.66565],
      [-61.326596, -12.668468],
      [-61.341182, -12.668604],
      [-61.340864, -12.682145],
      [-61.348998, -12.682009],
      [-61.348748, -12.690142],
      [-61.346839, -12.69037],
      [-61.345135, -12.693937],
      [-61.340217, -12.693903],
      [-61.340205, -12.69555],
      [-61.435637, -12.696042],
      [-61.43572, -12.673614],
      [-61.413863, -12.673795],
      [-61.413318, -12.669251],
      [-61.415408, -12.664253],
      [-61.416817, -12.664389],
      [-61.42033, -12.65436],
      [-61.400413, -12.651121],
      [-61.400231, -12.652575],
      [-61.379874, -12.650258],
      [-61.380238, -12.647713],
      [-61.375058, -12.646895],
      [-61.375126, -12.638523],
      [-61.361442, -12.636862],
      [-61.361517, -12.624743],
      [-61.359335, -12.623448],
      [-61.358404, -12.615394],
      [-61.361585, -12.615394],
      [-61.361676, -12.578042],
      [-61.332594, -12.57786],
    ]],
  },
  areaHa: 7638.4,
  pontos: 35,
};

export const TANARU_AMORTECIMENTO: TanaruPerimetro = {
  geometry: {
    type: 'Polygon' as const,
    coordinates: [[
      [-61.316556, -12.559542],
      [-61.316644, -12.561952],
      [-61.314786, -12.563507],
      [-61.314733, -12.565631],
      [-61.313618, -12.567076],
      [-61.313278, -12.592959],
      [-61.316382, -12.592941],
      [-61.317591, -12.591889],
      [-61.317574, -12.588768],
      [-61.319713, -12.589943],
      [-61.320309, -12.58975],
      [-61.319906, -12.58456],
      [-61.314347, -12.584332],
      [-61.314312, -12.581728],
      [-61.32174, -12.576121],
      [-61.323198, -12.578608],
      [-61.325589, -12.579372],
      [-61.325511, -12.584335],
      [-61.331594, -12.584309],
      [-61.331216, -12.627765],
      [-61.32543, -12.628522],
      [-61.325763, -12.660209],
      [-61.331064, -12.661996],
      [-61.331125, -12.664389],
      [-61.325627, -12.664817],
      [-61.325695, -12.669342],
      [-61.32655, -12.669388],
      [-61.326515, -12.674325],
      [-61.332193, -12.674329],
      [-61.332011, -12.669422],
      [-61.340243, -12.669498],
      [-61.339933, -12.683077],
      [-61.348036, -12.682925],
      [-61.347854, -12.689362],
      [-61.346234, -12.689529],
      [-61.344537, -12.693043],
      [-61.339304, -12.692994],
      [-61.339266, -12.696451],
      [-61.341284, -12.696515],
      [-61.332212, -12.703407],
      [-61.332333, -12.706951],
      [-61.327955, -12.707103],
      [-61.326717, -12.705053],
      [-61.320987, -12.705087],
      [-61.320845, -12.713438],
      [-61.363606, -12.713646],
      [-61.363801, -12.696521],
      [-61.386627, -12.696671],
      [-61.385407, -12.699154],
      [-61.385484, -12.702358],
      [-61.38763, -12.702361],
      [-61.387619, -12.699496],
      [-61.389772, -12.696685],
      [-61.432875, -12.696938],
      [-61.433806, -12.698478],
      [-61.434853, -12.698471],
      [-61.434956, -12.696972],
      [-61.436569, -12.696935],
      [-61.436648, -12.67272],
      [-61.414685, -12.672887],
      [-61.414246, -12.669403],
      [-61.416003, -12.66523],
      [-61.417457, -12.665351],
      [-61.417752, -12.664503],
      [-61.420307, -12.664399],
      [-61.423577, -12.662262],
      [-61.423136, -12.661483],
      [-61.420667, -12.662894],
      [-61.420755, -12.655888],
      [-61.421556, -12.653648],
      [-61.419136, -12.653243],
      [-61.418766, -12.65226],
      [-61.420897, -12.6509],
      [-61.420485, -12.650342],
      [-61.418495, -12.651106],
      [-61.418938, -12.64155],
      [-61.419433, -12.640508],
      [-61.421121, -12.639845],
      [-61.422833, -12.637765],
      [-61.426669, -12.637942],
      [-61.426786, -12.640234],
      [-61.437037, -12.647031],
      [-61.437991, -12.643926],
      [-61.435916, -12.644456],
      [-61.432447, -12.642593],
      [-61.432463, -12.638049],
      [-61.403573, -12.633202],
      [-61.403524, -12.647402],
      [-61.400637, -12.650227],
      [-61.399644, -12.650068],
      [-61.399417, -12.651568],
      [-61.38786, -12.65025],
      [-61.387363, -12.647382],
      [-61.386275, -12.647382],
      [-61.386558, -12.650114],
      [-61.380908, -12.649477],
      [-61.381256, -12.646963],
      [-61.37597, -12.64613],
      [-61.376031, -12.637731],
      [-61.370199, -12.637027],
      [-61.370442, -12.632255],
      [-61.368771, -12.629964],
      [-61.369619, -12.6281],
      [-61.368542, -12.627081],
      [-61.366684, -12.629317],
      [-61.366347, -12.627434],
      [-61.364887, -12.625633],
      [-61.362433, -12.625485],
      [-61.362441, -12.624228],
      [-61.360199, -12.622903],
      [-61.359423, -12.616291],
      [-61.362497, -12.616295],
      [-61.362505, -12.614617],
      [-61.363782, -12.613624],
      [-61.363065, -12.61071],
      [-61.363594, -12.605723],
      [-61.362526, -12.602666],
      [-61.362545, -12.599935],
      [-61.363173, -12.598286],
      [-61.365068, -12.598029],
      [-61.368786, -12.593811],
      [-61.367775, -12.592796],
      [-61.366287, -12.593046],
      [-61.363976, -12.595014],
      [-61.363069, -12.59434],
      [-61.363055, -12.593054],
      [-61.364373, -12.590856],
      [-61.364257, -12.587565],
      [-61.363076, -12.586566],
      [-61.362581, -12.585074],
      [-61.362581, -12.582151],
      [-61.363466, -12.579181],
      [-61.363144, -12.577607],
      [-61.362595, -12.577141],
      [-61.331685, -12.576948],
      [-61.331655, -12.57975],
      [-61.327338, -12.57839],
      [-61.323006, -12.575999],
      [-61.31893, -12.569268],
      [-61.321102, -12.566885],
      [-61.32069, -12.566219],
      [-61.318887, -12.567767],
      [-61.316438, -12.566042],
      [-61.31607, -12.564771],
      [-61.318486, -12.559561],
      [-61.316556, -12.559542],
    ]],
  },
  areaHa: 9724.4,
  pontos: 145,
};
